import { render, staticRenderFns } from "./DialogCustomize.vue?vue&type=template&id=16d77213&"
import script from "./DialogCustomize.vue?vue&type=script&lang=js&"
export * from "./DialogCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports